export default "__VITE_ASSET__BSVI45vm__"